/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerformat1Inputs */

const en_flyerformat1 = /** @type {(inputs: Flyerformat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const de_flyerformat1 = /** @type {(inputs: Flyerformat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

/**
* | output |
* | --- |
* | "Format" |
*
* @param {Flyerformat1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerformat1 = /** @type {((inputs?: Flyerformat1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerformat1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerformat1(inputs)
	return de_flyerformat1(inputs)
});
export { flyerformat1 as "flyerFormat" }